export default {
  title: 'Myyntiyhteenveto',
  description: 'Valitun jakson myynti — käytä tämän ravintolan laskutuksen täsmäytykseen.',
  filters: {
    period: 'Jakso',
  },
  presets: {
    this_month: 'Tämä kuukausi',
    last_month: 'Edellinen kuukausi',
    last_30_days: 'Viimeiset 30 päivää',
    this_year: 'Tämä vuosi',
  },
  fields: {
    orders_count: 'Tilaukset',
    net_sales: 'Nettomyynti',
    sales_tax: 'Myyntivero',
    gross_sales: 'Bruttomyynti',
    delivery_fee_tax: 'Toimitusmaksu (vero)',
    delivery_fee_gross: 'Toimitusmaksu (brutto)',
    tips_gross: 'Tipit (brutto)',
    total: 'Yhteensä',
  },
  kpi: {
    before_tax: 'ennen veroa',
    tips: 'kerätty ravintolalle',
    owed_to_restaurant: 'ravintolalle maksettava',
  },
  table: {
    title: 'Erittely',
    subtitle: '{{range}} · Kaikki summat valuutassa {{currency}}',
    field: 'Kenttä',
    amount: 'Summa',
    empty: 'Ei tilauksia valitulla ajanjaksolla',
    footnote:
      'Nettomyynti ei sisällä veroa; bruttomyynti lisää sen takaisin · Yhteissumma on alustamaksujen jälkeen, joten se ei ole asiakkaan maksama summa · Hyvitykset ja maksupalautukset on vähennetty · Summat valuutassa {{currency}}',
  },
  buttons: {
    export_csv: 'Vie CSV',
    refresh: 'Päivitä',
    retry: 'Yritä uudelleen',
  },
  errors: {
    failed_to_load: {
      title: 'Myyntiyhteenvetoa ei voitu ladata',
      description: 'Raportin lataamisessa tapahtui virhe. Yritä uudelleen.',
    },
  },
};
